(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';

  function isMobileViewport() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function getVisibleImage(slide) {
    var images = slide.querySelectorAll('.hero-new-banner__image');
    var i;
    var image;

    for (i = 0; i < images.length; i += 1) {
      image = images[i];
      if (image.offsetParent !== null || image.offsetWidth > 0) {
        return image;
      }
    }

    return images[0] || null;
  }

  function initSlideMedia(slide) {
    if (slide.dataset.mediaLoaded === 'true') return;
    slide.dataset.mediaLoaded = 'true';

    var image = getVisibleImage(slide);
    var section = slide.closest('[data-hero-new-banner]');

    function markLoaded() {
      slide.classList.add('is-loaded');
      if (section && slide.classList.contains('is-active')) {
        syncInactiveSlides(section);
      }
    }

    if (!image) {
      markLoaded();
      return;
    }

    if (image.complete && image.naturalWidth > 0) {
      markLoaded();
    } else {
      image.addEventListener('load', markLoaded, { once: true });
      image.addEventListener('error', markLoaded, { once: true });
    }
  }

  function getAllVideos(slide) {
    return Array.prototype.slice.call(slide.querySelectorAll('.hero-new-banner__video-element'));
  }

  function isVideoForCurrentViewport(video) {
    var wrapper = video.closest('.hero-new-banner__video');
    if (!wrapper) return true;

    var isDesktopWrapper = wrapper.classList.contains('hero-new-banner__video--desktop');
    var isMobileWrapper = wrapper.classList.contains('hero-new-banner__video--mobile');
    var mobile = isMobileViewport();

    if (isDesktopWrapper && isMobileWrapper) return true;
    if (isDesktopWrapper) return !mobile;
    if (isMobileWrapper) return mobile;
    return true;
  }

  function getVisibleVideos(slide) {
    var visible = getAllVideos(slide).filter(isVideoForCurrentViewport);
    return visible.length ? visible : getAllVideos(slide);
  }

  function suspendVideo(video) {
    video.pause();

    try {
      video.currentTime = 0;
    } catch (error) {
      /* Safari pode bloquear seek antes do metadata */
    }

    video.preload = 'none';
    delete video.dataset.heroPrepared;
  }

  function suspendVideos(slide) {
    getAllVideos(slide).forEach(suspendVideo);
  }

  function prepareVideo(video) {
    if (video.dataset.heroPrepared === 'true') return Promise.resolve(video);

    video.dataset.heroPrepared = 'true';
    video.preload = 'auto';
    video.load();

    return new Promise(function (resolve) {
      if (video.readyState >= 3) {
        resolve(video);
        return;
      }

      function onReady() {
        video.removeEventListener('canplay', onReady);
        video.removeEventListener('loadeddata', onReady);
        resolve(video);
      }

      video.addEventListener('canplay', onReady, { once: true });
      video.addEventListener('loadeddata', onReady, { once: true });

      window.setTimeout(function () {
        resolve(video);
      }, 4000);
    });
  }

  function playVideos(slide) {
    var videos = getVisibleVideos(slide);
    if (!videos.length) return;

    getAllVideos(slide).forEach(function (video) {
      if (videos.indexOf(video) === -1) {
        suspendVideo(video);
      }
    });

    videos.forEach(function (video) {
      prepareVideo(video).then(function (readyVideo) {
        var playPromise = readyVideo.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      });
    });
  }

  function syncInactiveSlides(section) {
    var slides = section.querySelectorAll('.hero-new-banner__slide');

    if (isMobileViewport()) {
      slides.forEach(function (slide) {
        slide.style.height = '';
      });
      return;
    }

    var activeSlide = section.querySelector('.hero-new-banner__slide.is-active');
    if (!activeSlide) return;

    var trackHeight = activeSlide.offsetHeight;

    slides.forEach(function (slide) {
      if (slide.classList.contains('is-active')) {
        slide.style.height = '';
        return;
      }
      slide.style.height = trackHeight ? trackHeight + 'px' : '';
    });
  }

  function initHeroNewBanner(section) {
    if (section.dataset.heroInitialized === 'true') return;
    section.dataset.heroInitialized = 'true';

    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-slide]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-hero-dot]'));
    var prevBtn = section.querySelector('[data-hero-prev]');
    var nextBtn = section.querySelector('[data-hero-next]');
    var autoplayEnabled = section.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) || 6000;
    var currentIndex = slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });

    if (currentIndex < 0) currentIndex = 0;

    var autoplayTimer = null;
    var resizeTimer = null;
    var mobileMedia = window.matchMedia(MOBILE_QUERY);

    slides.forEach(initSlideMedia);

    slides.forEach(function (slide, index) {
      if (index !== currentIndex) {
        suspendVideos(slide);
      }
    });

    function updateFocusableElements() {
      slides.forEach(function (slide, index) {
        var isActive = index === currentIndex;
        slide.querySelectorAll('.hero-new-banner__button').forEach(function (button) {
          button.tabIndex = isActive ? 0 : -1;
        });
      });
    }

    function goTo(index) {
      if (!slides.length) return;

      var nextIndex = (index + slides.length) % slides.length;
      if (nextIndex === currentIndex) return;

      var previousSlide = slides[currentIndex];
      var nextSlide = slides[nextIndex];

      suspendVideos(previousSlide);

      previousSlide.classList.remove('is-active');
      previousSlide.setAttribute('aria-hidden', 'true');

      nextSlide.style.height = '';
      nextSlide.classList.add('is-active');
      nextSlide.setAttribute('aria-hidden', 'false');

      initSlideMedia(nextSlide);

      window.requestAnimationFrame(function () {
        playVideos(nextSlide);
        syncInactiveSlides(section);
      });

      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === nextIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      currentIndex = nextIndex;
      updateFocusableElements();
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled || slides.length <= 1) return;
      if (document.hidden) return;

      autoplayTimer = window.setInterval(function () {
        goTo(currentIndex + 1);
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function handleVisibility() {
      if (document.hidden) {
        slides.forEach(suspendVideos);
        stopAutoplay();
        return;
      }

      playVideos(slides[currentIndex]);
      startAutoplay();
    }

    function handleViewportChange() {
      slides.forEach(function (slide, index) {
        if (index !== currentIndex) {
          suspendVideos(slide);
        }
      });

      playVideos(slides[currentIndex]);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(currentIndex - 1);
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(currentIndex + 1);
        startAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.heroDot, 10));
        startAutoplay();
      });
    });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    section.addEventListener('focusin', stopAutoplay);
    section.addEventListener('focusout', function (event) {
      if (!section.contains(event.relatedTarget)) {
        startAutoplay();
      }
    });

    document.addEventListener('visibilitychange', handleVisibility);

    if (typeof mobileMedia.addEventListener === 'function') {
      mobileMedia.addEventListener('change', handleViewportChange);
    } else if (typeof mobileMedia.addListener === 'function') {
      mobileMedia.addListener(handleViewportChange);
    }

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        syncInactiveSlides(section);
        handleViewportChange();
      }, 150);
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              slides.forEach(suspendVideos);
              stopAutoplay();
              return;
            }

            playVideos(slides[currentIndex]);
            startAutoplay();
          });
        },
        { threshold: 0.15 }
      );

      observer.observe(section);
      section._heroObserver = observer;
    }

    playVideos(slides[currentIndex]);
    updateFocusableElements();
    syncInactiveSlides(section);
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-hero-new-banner]').forEach(initHeroNewBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-hero-new-banner]');
    if (section) initHeroNewBanner(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('[data-hero-new-banner]');
    if (!section) return;

    if (section._heroObserver) {
      section._heroObserver.disconnect();
    }

    section.querySelectorAll('.hero-new-banner__video-element').forEach(suspendVideo);
  });
})();
